import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen grain flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-card border rounded-2xl p-8 text-center space-y-4">
        <h1 className="font-display text-3xl tracking-tight">No worries.</h1>
        <p className="text-sm text-muted-foreground">
          You closed the checkout — nothing was charged. Free stays generous.
        </p>
        <div className="flex gap-2 pt-2">
          <Button variant="outline" onClick={() => nav("/dashboard")} className="rounded-full h-11 flex-1" data-testid="cancel-back-dashboard">
            <ArrowLeft className="w-4 h-4 mr-2" strokeWidth={1.75} /> Back to calendar
          </Button>
          <Button onClick={() => nav("/pricing")} className="rounded-full h-11 flex-1 bg-terracotta hover:bg-terracotta/90 text-white" data-testid="cancel-try-again">
            See plans again
          </Button>
        </div>
      </div>
    </div>
  );
}
